import { InjectionToken } from '@angular/core';

export const BASE_URL = new InjectionToken<string>('BASE_URL');

export const LOG_LEVEL = new InjectionToken<number>('LOG_LEVEL');
